module.exports = __webpack_public_path__ + "static/img/subject.68609e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/no/subject.png
// module id = 1419
// module chunks = 1